
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foreign-rights",
      function () {
        return require("private-next-pages/foreign-rights/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foreign-rights"])
      });
    }
  